
import { Review } from "./review.model";
import { RatingsSummary } from "./ratings-summary";

import { UserComment } from "./user-comment.model";
import { Proposal } from "../../buy/models/proposal.model";
import { Alert } from "../../car/models/alert.model";
import { PhoneNumber } from "../../common/models/address.model";
import { Appointment } from "../../common/models/appointment.model";
import { Conversation } from "../../common/models/conversation.model";
import { Message } from "../../common/models/message.model";
import { Job } from "../../keep/models/job.model";
import { KeepOffer } from "../../keep/models/keep-offer.model";
import { Booking } from "../../rent/models/booking.model";
import { DealerStatus } from "../constants/dealer-basic-data";
import { Contract } from "./contract.model";


export class Dealer {

  username = "";
  dealerType = "";
  partner = false;
  prospect = false;
  //registrationDate = DateTime.now();
  created="";
  civility = "";
  firstName = "";
  lastName = "";
  businessName = "";
  businessType = "";
  address = "";
  email = "";

  favoriteProviderIds: string[] = [];

  status: DealerStatus = DealerStatus.AWAITING_VERIFICATION;

  countryOrigin = "";
  countryResident = "";
  cityResident = '';

  //phoneCode = 0;
  phoneNumber: PhoneNumber = new PhoneNumber();
  
  reviews: Review[] = [];
  notifications: Notification[] = [];

  ratingsSummary: RatingsSummary = new RatingsSummary();
  // ratingsCounts: number[];
  // ratingsIndicators: number[];
	// ratingsAverage: number = 0 ;

  //carFavorites: string[] = [];

  comments: UserComment[] = [];
  messages: Message[] = [];
  
  keepOffer: KeepOffer = new KeepOffer()

  buyCustomer: boolean = true;
  buyProvider: boolean = true;

  rentCustomer: boolean = true;
  rentProvider: boolean = true;

  keepCustomer: boolean = true;
  keepProvider: boolean = true;

  imagesFilenames: string[] = [];
  documentsFilenames: string[] = [];

  alerts: Alert[] = [];
  appointments: Appointment[] = [];
  conversations: Conversation[] = [];

  proposals: Proposal[] = [];
  bookings: Booking[] = [];
  jobs: Job[] = [];

  customerContracts: Contract[] = [];
  providerContracts: Contract[] = [];

  myOwners: Dealer[] = [];
  myProviders: Dealer[] = [];

  // public getRatingsAverage(): any{
  //   let totalSum = 0;
  //   let totalCount = 0;

  //   let i = this.ratingsCounts.length;

  //   while(i>0){
  //     totalSum+= this.ratingsCounts[i-1] * i;
  //     totalCount+= this.ratingsCounts[i-1];
  //     i--;
  //   }

  //   return (totalCount === 0) ? 0 : totalSum/totalCount;
  // }

  

  constructor(){
		//this.carFavorites = [];

    this.alerts = [];
    this.reviews = [];
    this.comments = [];
    this.messages = [];

    this.favoriteProviderIds = [];

    this.customerContracts = [];
    this.providerContracts = [];

    this.imagesFilenames = [];
    this.documentsFilenames = [];

    this.alerts = [];
    this.appointments = [];
    this.conversations = [];

    this.proposals = [];
    this.bookings = [];
    this.jobs = [];

    this.myOwners = [];
    this.myProviders = [];
    
	}
}